import React, { useEffect, useRef } from 'react';

import YTVideoDetailHolder from './YTVideoDetailStyles';

const YTVideoDetail = ({video, selectedVideo, selected}) => {
	const videoContainer = useRef(null);

	useEffect(()=>{
		if(selectedVideo && videoContainer) {
			videoContainer.current.focus();
		}
	},[selectedVideo]);

	if(!video) {
		return <div></div>;
	} else {
		const videoSrc = `https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`;

		return (
			<YTVideoDetailHolder className={`${selected ? "show" : "hide"}`}>
				<div className="yt-video-embed">
					<iframe ref={videoContainer} title="yt-video-player" src={videoSrc}/>
				</div>
			</YTVideoDetailHolder>
		)
	}
}

export default YTVideoDetail;